import { put, takeEvery } from 'redux-saga/effects';

import { error } from '@pressreader/logger';
import { BookmarkType, CollectionContentTypes } from '@pressreader/social-types';

import { addBookmarkAction, addBookmarkDone, addBookmarkFailed, type AddBookmarkPayload } from '../../actions';
import { createOrGetPageSetSaga } from '../issue.pageset/issue.pageset.loaders';

import { addPageSetBookmarkSaga, upsertContentCollectionsSaga } from './bookmarks.loaders';

function* addBookmarkForPageSet(bookmarkDetails: ReturnType<typeof addBookmarkAction>['payload']) {
    const { bookmarkType, bookmarkData, collections } = bookmarkDetails;

    let pageSetId: string | undefined;
    if (bookmarkType === BookmarkType.pages) {
        const pagesData = bookmarkData as AddBookmarkPayload<BookmarkType.pages>['bookmarkData'];
        const pageSet = yield* createOrGetPageSetSaga(pagesData.issueKey, pagesData.pages);

        pageSetId = pageSet.id;
    }
    if (bookmarkType === BookmarkType.pageSet) {
        pageSetId = (bookmarkData as AddBookmarkPayload<BookmarkType.pageSet>['bookmarkData']).pageSetId;
    }

    if (!pageSetId) {
        throw new Error('PageSet ID is not specified');
    }
    yield* addPageSetBookmarkSaga(pageSetId, collections || []);
}

function* addBookmark({ payload: bookmarkDetails }: ReturnType<typeof addBookmarkAction>) {
    try {
        if (!bookmarkDetails) {
            throw new Error('Bookmark is not specified');
        }

        const { bookmarkType, bookmarkData, collections } = bookmarkDetails;

        if (bookmarkType === BookmarkType.article) {
            const { articleId } = bookmarkData as AddBookmarkPayload<BookmarkType.article>['bookmarkData'];
            yield* upsertContentCollectionsSaga({
                contentId: articleId,
                collections: collections ?? [],
                contentType: CollectionContentTypes.article,
            });
        } else {
            yield* addBookmarkForPageSet(bookmarkDetails);
        }

        yield put(addBookmarkDone(bookmarkDetails));
    } catch (e) {
        error(e);
        yield put(addBookmarkFailed(bookmarkDetails));
    }
}

function* saga() {
    yield takeEvery(addBookmarkAction, addBookmark);
}

export { saga };
